import React, { useMemo } from 'react';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';

export function MobileCombinations({
  t,
  winningAmount,
  winCombination,
  showCardsImages,
  setShowCardsImages,
  currencySymbolOrCode,
}) {
  const winBetInfo = useMemo(() => {
    if (winningAmount && winCombination) {
      return COMBINATIONS_PAYOUTS.find((item) => item.winType === winCombination);
    }
    return null;
  }, [winningAmount, winCombination]);

  return (
    <div className='tp-g-mobile-top'>
      {!winBetInfo && (
        <div className='switch-box' onClick={() => setShowCardsImages((prev) => !prev)}>
          <i className='icon-tp-replace ' />
        </div>
      )}
      {winBetInfo ? (
        <div className='popup-mob-wrp'>
          <div className='mob-row-wrp'>
            <div className='cont-row active'>
              <div className='b-text-b-img'>
                <p className='comb-name-mob'>{t(winBetInfo.type)}</p>
              </div>
              <div className='b-text-b-text'>
                <p className='cof-text-mob'>x{winBetInfo.odd}</p>
              </div>
            </div>
          </div>
          <div className='popup-info'>
            <div className='popup-header'>
              <div className='header-line-left' />
              <p className='popup-header-name'>{t('YOU_WIN')}</p>
              <div className='header-line-right' />
            </div>
            <p className='popup-header-amount'>
              {winningAmount}
              {currencySymbolOrCode}
            </p>
          </div>
        </div>
      ) : (
        <div className='inner-mb-block'>
          {COMBINATIONS_PAYOUTS.map((item, index, arr) => {
            if (!index) {
              return (
                <div className='mob-row-wrp' key={item.winType}>
                  <div className={`cont-row ${winCombination === item.winType ? 'active' : ''}`}>
                    {showCardsImages ? (
                      <div className='mob-img-block'>
                        <img src={item.imgMobile} alt='a' />
                      </div>
                    ) : (
                      <div className='b-text-b-img'>
                        <p className='comb-name-mob'>{t(item.type)}</p>
                      </div>
                    )}
                    <div className='b-text-b-text'>
                      <p className='cof-text-mob'>x{item.odd}</p>
                    </div>
                  </div>
                </div>
              );
            }
            if (index % 2) {
              return (
                <div className='mob-row-wrp' key={item.winType}>
                  <div className={`cont-row ${winCombination === item.winType ? 'active' : ''}`}>
                    {showCardsImages ? (
                      <div className='mob-img-block'>
                        <img src={arr[index].imgMobile} alt='a' />
                      </div>
                    ) : (
                      <div className='b-text-b-img'>
                        <p className='comb-name-mob'>{t(arr[index].type)}</p>
                      </div>
                    )}
                    <div className='b-text-b-text'>
                      <p className='cof-text-mob'>x{arr[index].odd}</p>
                    </div>
                  </div>
                  <div
                    className={`cont-row ${
                      winCombination === arr[index + 1].winType ? 'active' : ''
                    }`}
                  >
                    {showCardsImages ? (
                      <div className='mob-img-block'>
                        <img src={arr[index + 1].imgMobile} alt='a' />
                      </div>
                    ) : (
                      <div className='b-text-b-img'>
                        <p className='comb-name-mob'>{t(arr[index + 1].type)}</p>
                      </div>
                    )}
                    <div className='b-text-b-text'>
                      <p className='cof-text-mob'>x{arr[index + 1].odd}</p>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
}
